<script>

export default {
  name: "AkDebug",
  props: {
    dto: {
      type: Object,
      default: null
    }
  },
}
</script>

<template>
<div v-if="this.dto?.debugFo" style="border: 1px solid #ccc; padding: 12px; border-radius: 6px; margin-bottom: 12px;">
   <h5>Debug de {{ dto?.page }}</h5>
    <slot />

    <details class="mt-2">
      <summary style="cursor: pointer;">JSON brut</summary>
      <pre class="mb-0">{{ dto }}</pre>
    </details>
</div>
</template>